import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './redux/store';
import { defineCustomElements, addTheme } from '@scania/components';
import { theme as scania } from '@scania/theme-light';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';
import './register-webcomponents';
import '@scania/tegel/dist/tegel/tegel.css';

import App from './App';
import './i18n';
 
// ✅ REACT 18 root API
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);

root.render(
  <Suspense fallback={<div>Loading... </div>}>
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
        <App />
        </Provider>
      </MsalProvider>
    </React.StrictMode>
  </Suspense>
);

defineCustomElements();
addTheme(scania);
